import { useEffect, useState } from "react";
import { Column } from "../../../components/containers";
import { AlignItems } from "../../../components/containers/types";
import { CheckBox } from "../../../components/inputs";
import { Heading } from "../../../components/typography";
import { useThemeStore } from "../../../stores";
import { HistoryQueryKind } from "../../../types";
import { HistoryFormSelectorProps } from "./types";

const HistoryFormSelector = <T extends HistoryQueryKind>({
  label,
  options,
  setValues,
  values,
  soloField,
  props,
  className,
  style,
}: HistoryFormSelectorProps<T>) => {
  const theme = useThemeStore((s) => s.theme);

  const [ro, setRo] = useState<boolean[]>([]);

  useEffect(() => {
    let res: boolean[] = [];

    Object.keys(options).forEach(() => res.push(false));

    setRo(res);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setValue = (v: boolean, k: T): void => {
    if (v) {
      if (soloField && k === soloField) {
        setValues([soloField]);
        setRo((prev) => {
          return prev.map((_, i) => (i === 0 ? false : true));
        });
      } else setValues((prev) => [...prev, k]);
    } else {
      if (soloField && k === soloField) {
        setValues([]);
        setRo((prev) => {
          return prev.map(() => false);
        });
      } else setValues((prev) => prev.filter((p) => p !== k));
    }
  };

  return (
    <Column
      style={{ width: "100%", ...style }}
      alignItems={AlignItems.Start}
      className={className}
      props={props}
      gap={10}
    >
      <Heading color={theme.textOnOverlay}>{label}</Heading>

      {Object.keys(options).map((k, i) => (
        <CheckBox
          key={k}
          color={theme.textOnOverlay}
          label={options[k as T]}
          value={values.includes(k as T)}
          setValue={(v) => setValue(v, k as T)}
          readOnly={ro[i]}
        />
      ))}
    </Column>
  );
};

export default HistoryFormSelector;
